import React from "react";
import { useTheme } from "../context/context";
import './style.css'

export default function Downloader({ url, name }) {
    const onButtonClick = () => {
        const pdfUrl = url;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const { fontSize } = useTheme();
    return (
        <>
            <div>
                <div onClick={onButtonClick} style={{ cursor: "pointer", fontSize: `${fontSize - 0.1}rem`, margin: "10px 0" }} className="downloader_text">
                    <span style={{ color: "" }}>{name}</span>
                    <i className={"fa fa-download"} style={{ marginLeft: "5px" }} />
                </div>
            </div>
        </>
    );
};